import logoImg from '../../assets/Logo.svg';
import { Container, Content } from './styles';

interface HomeProps {
    onOpenNewTransactionModal: () => void;
}

export function Home({ onOpenNewTransactionModal }: HomeProps) {
    return (
        <Container>
            <Content>
                <img src={logoImg} alt="Oliveira Jardins" />
                <button type="button" onClick={onOpenNewTransactionModal}>
                    Nova transação
                </button>
            </Content>
        </Container>
    )
}